import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import Checkbox from "../../../shared/custom-components/checkbox";
import FilterComponent from "../../../utils/searchBar";
import Table from "../../../shared/table";
import TableActions from "./tableActions";
import useApi from "../../../hooks/useApi";
import { loadingModal } from "../../../utils/functions";

const AddClient = ({
  changeStep,
  handleSubmit,
  countryCode,
  providerId,
  currency,
}) => {
  const [state, setState] = useState({
    data: [],
    isReady: false,
    page: 0,
    search: undefined,
    sizePerPage: 10,
    totalSize: 0,
  });

  const [selectedItems, setSelectedItems] = useState({});
  const [loading, setLoading] = useState(false);

  const { cancellCall, getApiCAll } = useApi();
  const { t } = useTranslation();

  const isSelected = (id) => !!selectedItems[id];
  const getGlobalAcceptance = (id) => !!selectedItems[id]?.toGlobalAcceptance;

  const handleSelect = (id) => {
    if (isSelected(id)) {
      // eslint-disable-next-line no-unused-vars
      const { [id]: key, ...rest } = selectedItems;
      setSelectedItems(rest);
    } else {
      setSelectedItems({
        ...selectedItems,
        [id]: { toGlobalAcceptance: false },
      });
    }
  };

  const handleGlobalAcceptance = (id) => {
    setSelectedItems({
      ...selectedItems,
      [id]: { toGlobalAcceptance: !getGlobalAcceptance(id) },
    });
  };

  const handleSearch = (property, query) => {
    const search = query.trim() ? `${property}/eq/${query}` : undefined;

    if (search !== state.search) setSelectedItems({});
    setState((prev) => ({
      ...prev,
      page: 0,
      search,
      sizePerPage: 10,
    }));
  };

  const getData = async () => {
    setLoading(true);
    try {
      const {
        data: { data },
      } = await getApiCAll(
        `/account/company-info/${countryCode}/${providerId}/${currency}`,
        undefined,
        { page: state.page, size: state.sizePerPage, search: state.search }
      );

      setState({
        ...state,
        //data sin informacion
        data: data.content.filter(({ customerId }) => customerId),
        totalSize: data.totalElements,
        isReady: true,
      });
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    getData();

    return () => cancellCall();
  }, [state.page, state.search]);

  const checkboxItem = ({ companyId, accountCurrency }, global = false) => {
    const id = `${companyId}-${accountCurrency}`;
    const selected = isSelected(id);
    const onChange = !global ? handleSelect : handleGlobalAcceptance;

    return (
      <Checkbox
        checked={!global ? selected : getGlobalAcceptance(id)}
        disabled={!global ? false : !selected}
        onChange={() => onChange(id)}
      />
    );
  };

  const onTableChange = (params) => {
    setState({ ...state, ...params });
    return Promise.resolve();
  };

  const sendData = () => {
    const data = Object.keys(selectedItems).map((key) => {
      const [companyId, accountCurrency] = key.split("-");
      return {
        companyId: +companyId,
        toGlobalAcceptance: selectedItems[key].toGlobalAcceptance,
        accountCurrency,
      };
    });

    handleSubmit(data);
  };

  return (
    <>
      {state.isReady && (
        <>
          <div className="flex-element justify-content-end">
            <FilterComponent filter={filters} searchFnc={handleSearch} />
          </div>
          <Table
            {...state}
            onTableChange={onTableChange}
            headers={getHeaders(t, checkboxItem)}
            actions={
              <TableActions
                firstButton={{
                  onClick: () => changeStep(2),
                  label: t("general.special_codition.BACK"),
                }}
                secondButton={{
                  disabled: Object.keys(selectedItems).length === 0,
                  onClick: sendData,
                  label: t("general.special_codition.SEND_TO_APPROVAL"),
                }}
              />
            }
          />
        </>
      )}
      {loading && loadingModal()}
    </>
  );
};

export default AddClient;

const filters = [
  {
    name: i18next.t("general.placeholders.name"),
    property: "institution.companyName",
    operator: "eq",
  },
  {
    name: i18next.t("general.placeholders.id"),
    property: "institution.businessId",
    operator: "eq",
  },
];

const getHeaders = (t, cellFormatter) => {
  return [
    {
      selector: "checkbox",
      center: true,
      name: "",
      bodyStyle: { flexGrow: 0 },
      grow: 0,
      cellFormatter,
    },
    {
      selector: "customerId",
      name: t("providers.table.headers.idClient"),
    },
    {
      selector: "companyName",
      name: t("providers.table.headers.nameClient"),
    },
    {
      selector: "coutryCodeCompany",
      name: t("providers.table.headers.country"),
    },
    {
      selector: "accountCurrency",
      name: t("providers.table.headers.divisa"),
    },
    {
      selector: "accountNumber",
      name: t("providers.table.headers.providerAccount"),
    },
    {
      selector: "checkbox",
      center: true,
      name: t("providers.table.headers.global_approval"),
      cellFormatter: (row) => cellFormatter(row, true),
    },
  ];
};
